import { apiService } from './api'

// Email API service functions
export const adminEmailAPI = {
  // 메일 통계 조회
  getStats: async (days: number = 30) => {
    try {
      const response = await apiService.client.get(
        `/admin/email/stats?days=${days}`
      )
      return response.data.data
    } catch (error) {
      console.error('Failed to fetch email stats:', error)
      throw error
    }
  },

  // 메일 로그 조회
  getLogs: async (filters: any = {}) => {
    try {
      const params = new URLSearchParams()
      Object.keys(filters).forEach(key => {
        if (filters[key]) {
          params.append(key, filters[key])
        }
      })

      const response = await apiService.client.get(
        `/admin/email/logs?${params.toString()}`
      )
      return response.data.data
    } catch (error) {
      console.error('Failed to fetch email logs:', error)
      throw error
    }
  },

  // 메일 템플릿 조회
  getTemplates: async () => {
    try {
      const response = await apiService.client.get('/admin/email/templates')
      return response.data.data
    } catch (error) {
      console.error('Failed to fetch email templates:', error)
      throw error
    }
  },

  // 메일 템플릿 생성
  createTemplate: async (templateData: any) => {
    try {
      const response = await apiService.client.post(
        '/admin/email/templates',
        templateData
      )
      return response.data.data
    } catch (error) {
      console.error('Failed to create email template:', error)
      throw error
    }
  },

  // 메일 템플릿 수정
  updateTemplate: async (templateId: string, templateData: any) => {
    try {
      const response = await apiService.client.put(
        `/admin/email/templates/${templateId}`,
        templateData
      )
      return response.data.data
    } catch (error) {
      console.error('Failed to update email template:', error)
      throw error
    }
  },

  // 메일 템플릿 삭제
  deleteTemplate: async (templateId: string) => {
    try {
      const response = await apiService.client.delete(
        `/admin/email/templates/${templateId}`
      )
      return response.data.data
    } catch (error) {
      console.error('Failed to delete email template:', error)
      throw error
    }
  },

  // 개별 메일 발송
  sendEmail: async (emailData: any) => {
    try {
      const response = await apiService.client.post(
        '/admin/email/send-individual',
        emailData
      )
      return response.data.data
    } catch (error) {
      console.error('Failed to send email:', error)
      throw error
    }
  },

  // 벌크 메일 발송
  sendBulkEmail: async (bulkEmailData: any) => {
    try {
      const response = await apiService.client.post(
        '/admin/email/send-bulk',
        bulkEmailData
      )
      return response.data.data
    } catch (error) {
      console.error('Failed to send bulk email:', error)
      throw error
    }
  },
}

export default adminEmailAPI
